import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { isArray } from 'lodash';
import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import { AccidentMediaItem } from '../types/accident';

import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import { Grid02 } from 'untitledui-js-base';

interface AccidentsPhotosProps {
  photos: AccidentMediaItem[];
}

export const AccidentsPhotos = ({ photos }: AccidentsPhotosProps) => {
  const [openLightbox, setOpenLightbox] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const thumbnailsRef = React.useRef(null);

  const slides = photos.flatMap(({ values }) =>
    isArray(values) ? values.map((value) => ({ src: value.url })) : values ? [{ src: values.url }] : []
  );

  const handleImageClick = (index: number) => {
    setCurrentIndex(index);
    setOpenLightbox(true);
  };

  return (
    <>
      {photos?.map(({ label, values }, groupIndex) => (
        <Grid key={groupIndex} size={{ xs: 12, md: 6 }}>
          <Typography variant="h6">{label}</Typography>
          <Grid container spacing={3} mt={2}>
            {isArray(values)
              ? values.map((value, index) => (
                  <Grid size={{ xs: 12, md: 4 }} key={index} position="relative" sx={{ height: '200px' }}>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        zIndex: 10,
                        pointerEvents: 'none'
                      }}
                      color="white"
                    >
                      <Grid02 />
                    </Box>
                    <Box
                      component="img"
                      src={value.url}
                      width="100%"
                      height="auto"
                      sx={{
                        cursor: 'pointer',
                        position: 'absolute',
                        height: 1,
                        width: 1,
                        objectFit: 'cover',
                        objectPosition: 'center'
                      }}
                      onClick={() => handleImageClick(slides.findIndex((slide) => slide.src === value.url))}
                    />
                  </Grid>
                ))
              : values && (
                  <Grid size={12} position="relative">
                    <Box
                      component="img"
                      src={values.url}
                      width="100%"
                      height="auto"
                      sx={{ cursor: 'pointer' }}
                      onClick={() => handleImageClick(slides.findIndex((slide) => slide.src === values.url))}
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        zIndex: 10,
                        pointerEvents: 'none'
                      }}
                      color="white"
                    >
                      <Grid02 />
                    </Box>
                  </Grid>
                )}
          </Grid>
        </Grid>
      ))}

      <Lightbox
        plugins={[Thumbnails]}
        thumbnails={{ ref: thumbnailsRef }}
        open={openLightbox}
        close={() => setOpenLightbox(false)}
        index={currentIndex}
        slides={slides}
      />
    </>
  );
};
